
import { computed, defineComponent, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useClickLock } from '@/utils/useClickLock'
import resize from '@/layout/resize'
import { DeviceType } from '@/store/modules/app/state'

export default defineComponent({
  props: {
    formModel: {
      type: Object,
      default: () => {
        return null
      }
    },
    formStruct: {
      type: Array,
      default: () => []
    },
    formRules: {
      type: Object,
      default: () => {
        return null
      }
    },
    submitButton: {
      type: String,
      required: false,
      default: 'common.submit'
    },
    resetButton: {
      type: String,
      required: false,
      default: 'common.reset'
    },
    labelWidth: {
      type: String,
      required: false,
      default: '150px'
    }
  },
  emits: ['submit', 'reset'],
  setup(props, context) {
    const { t } = useI18n()
    const sFormRef = ref()
    const fM = ref(props.formModel)
    const fS = ref(props.formStruct)
    const { disabled: submitDisabled, lock: submitLock } = useClickLock(2000)
    const { disabled: resetDisabled, lock: resetLock } = useClickLock(2000)
    const { device } = resize()
    const bOffset = computed(() => {
      if (device.value === DeviceType.Mobile) {
        return 0
      } else if ((props.formStruct.length % 2) === 0) {
        return 2
      }
      return 11
    })
    const submitEmit = () => {
      submitLock(() => {
        context.emit('submit')
      })
    }
    const resetEmit = () => {
      resetLock(() => {
        sFormRef.value.resetFields()
        context.emit('reset')
      })
    }
    return {
      t,
      fM,
      fS,
      sFormRef,
      submitDisabled,
      resetDisabled,
      bOffset,
      submitEmit,
      resetEmit
    }
  }
})
